import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import AvatarPlaceholder from "assets/svgs/avatar.svg";
import Button from "@components/Button";

export default function Person({
  birthDate,
  deathDate,
  description,
  firstName,
  lastName,
  notes,
  photoUrl,
  relationship,
}) {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const hasDate =
    (birthDate && birthDate != "Invalid Date") ||
    (deathDate && deathDate != "Invalid Date");

  return (
    <div
      className={`bg-white border flex flex-col items-center justify-between rounded self-stretch my-3 text-center w-full mt-0.5 mx-3 p-6`}
    >
      {photoUrl ? (
        <div
          className="rounded-50pc h-28 mx-auto w-28"
          style={{
            backgroundImage: `url(${photoUrl})`,
            backgroundPosition: "center center",
            backgroundSize: "cover",
          }}
        ></div>
      ) : (
        <AvatarPlaceholder className="block h-28 mh-auto w-28" />
      )}
      <p className="pb-4 px-4 pt-6">
        <strong className="block text-sm font-semibold leading-snug">
          {firstName && firstName} {lastName && lastName}
        </strong>
        <span className="block capitalize mt-2 text-gray-500 text-xs">
          {relationship && relationship}
        </span>
      </p>
      <Button
        className="mt-4 w-full"
        emphasis="secondary"
        height="28"
        onClick={onOpenModal}
      >
        View Details
      </Button>
      <Modal
        classNames={{
          modal: "modal-submit-tip",
        }}
        open={open}
        onClose={onCloseModal}
        center
      >
        <div className="flex items-start pt-8">
          {photoUrl ? (
            <div
              className="flex-shrink-0 rounded-50pc h-28 w-28"
              style={{
                backgroundImage: `url(${photoUrl})`,
                backgroundPosition: "center center",
                backgroundSize: "cover",
              }}
            ></div>
          ) : (
            <AvatarPlaceholder className="block flex-shrink-0 h-24 w-24" />
          )}
          <div className="pl-4 pb-8">
            <p>
              {firstName && (
                <span className="text-xl">
                  {firstName} {lastName && lastName}
                </span>
              )}
              {relationship && (
                <span className="block capitalize font-semibold">
                  {relationship}
                </span>
              )}
            </p>
            <p className="text-sm">{description && description}</p>
          </div>
        </div>
        {hasDate && (
          <ul className="gap-4 grid grid-cols-2 mt-4 text-sm">
            {deathDate && deathDate != "Invalid Date" && (
              <li className="mt-2">
                <strong className="block">Date of Death</strong>
                {deathDate}
              </li>
            )}
            {birthDate && birthDate != "Invalid Date" && (
              <li className="mt-2">
                <strong className="block">Birthday</strong>
                {birthDate}
              </li>
            )}
          </ul>
        )}

        {notes && <p className="mt-6 text-sm">{notes}</p>}
      </Modal>
    </div>
  );
}
